import styled, { css } from 'styled-components';
import { hideVisually } from 'polished';
/**
 * Wrapper for the actual check box and its label.
 *
 * @return {jsx}
 */

export var Wrapper = styled.div.withConfig({
  displayName: "elements__Wrapper",
  componentId: "sc-1k6fwe8-0"
})(["display:flex;align-items:center;cursor:pointer;padding:0.6rem;", ";> input{", "}"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled && css(["cursor:not-allowed;"]);
}, hideVisually());
/**
 * StyledRadio of the actual check box.
 *
 * @return {jsx}
 */

export var StyledRadio = styled.div.withConfig({
  displayName: "elements__StyledRadio",
  componentId: "sc-1k6fwe8-1"
})(["display:flex;justify-content:center;align-items:center;width:1.6rem;height:1.6rem;margin-right:1.2rem;border:1px solid ", ";border-radius:50%;background:linear-gradient( 0deg,", " 0%,", " 100% );box-shadow:inset 0 2px 0 0 ", ",0 1px 1px 0 ", ";transition:background-color ease 0.25s;", ";&.checked{border:1px solid ", ";background:", " linear-gradient( 0deg,", " 0%,", " 100% );box-shadow:inset 0 0.2rem 0 0 ", ";transition:border ease 0.25s;position:relative;&:after{content:'';position:absolute;left:50%;top:50%;width:0.6rem;height:0.6rem;transform:translate3d(-50%,-50%,0);background-color:", ";border-radius:50%;}}"], function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.lightGrey;
}, function (_ref3) {
  var palette = _ref3.theme.palette;
  return palette.paleGrey;
}, function (_ref4) {
  var palette = _ref4.theme.palette;
  return palette.white;
}, function (_ref5) {
  var palette = _ref5.theme.palette;
  return palette.whiteOpacity(0.05);
}, function (_ref6) {
  var palette = _ref6.theme.palette;
  return palette.paleGrey;
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled && css(["opacity:0.4;"]);
}, function (_ref8) {
  var palette = _ref8.theme.palette;
  return palette.primary.dark;
}, function (_ref9) {
  var palette = _ref9.theme.palette;
  return palette.primary["default"];
}, function (_ref10) {
  var palette = _ref10.theme.palette;
  return palette.whiteOpacity(0);
}, function (_ref11) {
  var palette = _ref11.theme.palette;
  return palette.whiteOpacity(0.1);
}, function (_ref12) {
  var palette = _ref12.theme.palette;
  return palette.whiteOpacity(0.1);
}, function (_ref13) {
  var palette = _ref13.theme.palette;
  return palette.white;
});
/**
 * Label of the check box.
 *
 * @return {jsx}
 */

export var Label = styled.label.withConfig({
  displayName: "elements__Label",
  componentId: "sc-1k6fwe8-2"
})(["display:flex;align-items:center;cursor:pointer;position:relative;color:", ";", ";", ";"], function (_ref14) {
  var palette = _ref14.theme.palette;
  return palette.spaceGrey;
}, function (_ref15) {
  var disabled = _ref15.disabled;
  return disabled && css(["opacity:0.4;cursor:not-allowed;"]);
}, function (_ref16) {
  var checked = _ref16.checked;
  return checked && css(["color:", ";font-weight:", ";"], function (_ref17) {
    var palette = _ref17.theme.palette;
    return palette.primary["default"];
  }, function (_ref18) {
    var fonts = _ref18.theme.fonts;
    return fonts.weight.thick;
  });
});